export default __webpack_public_path__ + "static/media/poliruralplus-logo.37b73471.png";